import { logger } from "@/config/logger.config";
import { isDev } from "@/helpers/environment/environment.helpers";
import { InfoArgs } from "./useInfo.decl";

/* istanbul ignore next */
function fakeInfo(...args: InfoArgs): void {
  const [message, payload] = args;

  console.log(
    `🐶 %c[INFO]%c => message %c"${message}"%c${
      payload && ` with payload %c"${JSON.stringify(payload, null, 2)}"`
    }.`,
    "color: #80ffea;",
    "color: initial;",
    "color: #ff9580;",
    "color: initial;",
    "color: #8aff80;"
  );
}

export function useInfo() {
  const enhancedInfo = (...args: InfoArgs) => {
    const [message, payload] = args;
    logger.info(message, payload);
  };

  return {
    info: isDev() ? fakeInfo : enhancedInfo,
  };
}
